/* eslint-disable max-len */
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import {
  selectNonPublicStudentFormViewModel,
  selectHasSearchMatch,
  selectHas200500SearchMatch, selectAllowEdit,
} from '../../../redux/slices/nonPublicStudentSlice';
import { NonPublicStudentEntryModel } from '../../../types/NonPublicStudentEntryModel';
import { NonPublicStudentFormViewModel } from '../../../types/NonPublicStudentFormViewModel';
import { PanelType } from '../../../types/PanelType';
import { FormRadioListOrientation } from '../../../types/propTypes/FormRadioListPropTypes';
import { NonPublicStudentEntryValidationSchema } from '../../../types/Validation/NonPublicStudentEntryValidationSchema';
import { isStateNonAdmin } from '../../../utilities/userUtilities';
import FormDropdown from '../../FormInputs/FormDropdown/FormDropdown';
import FormRadioList from '../../FormInputs/FormRadioList/FormRadioList';
import Panel from '../../Panel/Panel';
import './NPSE_DemographicPanel.css';

const NPSE_DemographicPanel  : React.FC = () => {
  const formViewModel: NonPublicStudentFormViewModel = useAppSelector(
    selectNonPublicStudentFormViewModel
  );
  const [raceEnabled, setRaceEnabled] = useState(false);
  const { values, setFieldValue } =
    useFormikContext<NonPublicStudentEntryModel>();
  const [isRaceRequired, setIsRaceRequired] = useState(false);

  const getRequiredRaceLabel = (): string => {
    return isRaceRequired ? 'forced-required-label' : '';
  };

  const hasSearchMatch: boolean = useAppSelector(
    selectHasSearchMatch
  );

  const has200500SearchMatch: boolean = useAppSelector(
    selectHas200500SearchMatch
  );

  const allowEdit: boolean = useAppSelector(
    selectAllowEdit
  )

  const areFormComponentsDisabled: boolean =
    !allowEdit || !hasSearchMatch || has200500SearchMatch || isStateNonAdmin();

  useEffect(() => {
    if (values.hispanicOrLatinoEthnicity == 'Yes') {
      setRaceEnabled(false);
      setFieldValue('race', '');
      setIsRaceRequired(false);
    } else if (values.hispanicOrLatinoEthnicity == 'No') {
      setRaceEnabled(true);
      setIsRaceRequired(true);
    } else {
      setRaceEnabled(false);
      setIsRaceRequired(false);
    }
  }, [values, setFieldValue]);

  return (
    <Panel panelType={PanelType.INFO} heading="Student Demographics">
      <div className="field-row field-row-demographic">
        <FormDropdown
          displayName="Gender"
          field="sex"
          options={formViewModel.sexOptions}
          disabled={areFormComponentsDisabled}
          validationSchema={NonPublicStudentEntryValidationSchema}
        />
        <FormDropdown
          displayName="Ethnicity"
          field="hispanicOrLatinoEthnicity"
          options={formViewModel.hispanicOrLatinoEthnicityOptions}
          disabled={areFormComponentsDisabled}
          validationSchema={NonPublicStudentEntryValidationSchema}
        />
        <FormDropdown
          displayName="Race"
          field="race"
          classConfig={{ labelClasses: getRequiredRaceLabel() }}
          options={formViewModel.raceOptions}
          validationSchema={NonPublicStudentEntryValidationSchema}
          disabled={areFormComponentsDisabled || !raceEnabled }
        />
        <FormRadioList
          displayName="Special Education"
          field="specialEducation"
          options={formViewModel.specialEducationOptions}
          optionOrientation={FormRadioListOrientation.Horizontal}
          disabled={areFormComponentsDisabled}
          validationSchema={NonPublicStudentEntryValidationSchema}
        />
        <FormRadioList
          displayName="English Learner"
          field="englishLearnerStatus"
          options={formViewModel.englishLearnerStatusOptions}
          optionOrientation={FormRadioListOrientation.Horizontal}
          disabled={areFormComponentsDisabled}
          validationSchema={NonPublicStudentEntryValidationSchema}
        />
      </div>
    </Panel>
  );
};

export default NPSE_DemographicPanel;
